<!-- Role Dropdown button in the User tab -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { tick } from "svelte";
    export let options = [];
    export let selected_option = null;
    export let disabled = false;
    let dropdown;
    let is_open = false;
    let style = "";

    async function handle_menu() {
        if (is_open) {
            is_open = false;
            style = "";
        } else {
            style = "";
            is_open = true;
            await tick();
            if (
                dropdown.getBoundingClientRect().y +
                    dropdown.getBoundingClientRect().height >
                window.innerHeight
            ) {
                let height = dropdown.getBoundingClientRect().height + 40;
                style = "transform: translate3d(0px, -" + height + "px, 0px)";
            }
        }
    }
</script>

<button
    class="primary-color btn btn-transparent btn-normal btn-block dropdown-toggle "
    id="role_dropdown_0"
    type="button"
    {disabled}
    on:click|stopPropagation={handle_menu}
    on:blur={(e) => {
        if (is_open && !dropdown.contains(e.relatedTarget)) {
            handle_menu();
        }
    }}
    aria-haspopup="true"
    style="font-weight: bold;"
    aria-expanded="false">{selected_option.name}</button
>

{#if is_open}
    <div
        bind:this={dropdown}
        class="dropdown-menu filter_dropdown mt-1 show"
        aria-labelledby="role_dropdown_0"
        {style}
    >
        <div class="filter_dropdown_scrollable pl-2 pr-2">
            {#each options as option}
                <button
                    class="btn btn-primary btn-block btn-normal"
                    style="margin-top:0rem; padding-top:0.5rem;"
                    on:click|stopPropagation={() => {
                        selected_option = option;
                        is_open = false;
                        style = "";
                    }}>{option.name}</button
                >
            {/each}
        </div>
    </div>
{/if}
